import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(VDataTable, {
    staticClass: "elevation-0",
    attrs: {
      headers: _vm.headers,
      items: _vm.indicacoesDesempenho,
      search: _vm.opcoes.pesquisa,
      "sort-by": _vm.opcoes.ordenarPor,
      "sort-desc": _vm.opcoes.decrescente,
      "item-key": "id",
      "show-expand": "",
      "single-expand": "",
    },
    scopedSlots: _vm._u(
      [
        {
          key: "top",
          fn: function () {
            return [
              _c(
                VRow,
                [
                  _c(
                    VToolbar,
                    { attrs: { flat: "" } },
                    [
                      _c(VToolbarTitle, [
                        _c(
                          "h2",
                          {
                            staticClass:
                              "title primary--text text--darken-1 text-no-wrap",
                          },
                          [_vm._v(" INDICAÇÕES DE DESENVOLVIMENTO ")]
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VRow,
                [
                  _c(
                    VCol,
                    { attrs: { cols: "12", md: "4" } },
                    [
                      _c("app-sort", {
                        model: {
                          value: _vm.opcoes,
                          callback: function ($$v) {
                            _vm.opcoes = $$v
                          },
                          expression: "opcoes",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(VCol, { attrs: { cols: "0", md: "4" } }),
                  _c(
                    VCol,
                    { attrs: { cols: "12", md: "4" } },
                    [
                      _c("app-search", {
                        model: {
                          value: _vm.opcoes,
                          callback: function ($$v) {
                            _vm.opcoes = $$v
                          },
                          expression: "opcoes",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
        {
          key: `item.complexidadeResponsabilidade`,
          fn: function ({ item }) {
            return [
              _c(
                VTooltip,
                {
                  attrs: { top: "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function ({ on }) {
                          return [
                            _c(VCol, _vm._g({}, on), [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    item.complexidadeResponsabilidade.nome.toUpperCase()
                                  ) +
                                  " "
                              ),
                            ]),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                },
                [
                  _c("span", [
                    _vm._v(_vm._s(item.complexidadeResponsabilidade.descricao)),
                  ]),
                ]
              ),
            ]
          },
        },
        {
          key: `item.data-table-expand`,
          fn: function ({ item, expand, isExpanded }) {
            return [
              _c(
                VTooltip,
                {
                  attrs: { top: "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function ({ on }) {
                          return [
                            _c(
                              VBtn,
                              _vm._g(
                                {
                                  attrs: {
                                    height: "100%",
                                    text: "",
                                    width: "100%",
                                  },
                                  on: {
                                    click: function ($event) {
                                      expand(!isExpanded)
                                      _vm.generateColumns(
                                        _vm.colunas,
                                        item.competenciasTecnicas
                                      )
                                    },
                                  },
                                },
                                on
                              ),
                              [
                                _c(
                                  VBadge,
                                  {
                                    attrs: { right: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "badge",
                                          fn: function () {
                                            return [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    item.competenciasTecnicas
                                                      .length
                                                  )
                                                ),
                                              ]),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _c(
                                      VIcon,
                                      {
                                        attrs: {
                                          color: "grey lighten-0",
                                          large: "",
                                        },
                                      },
                                      [_vm._v(" build ")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                },
                [
                  _c("span", [
                    _vm._v("Clique para exibir as competências técnicas"),
                  ]),
                ]
              ),
            ]
          },
        },
        {
          key: "expanded-item",
          fn: function ({ headers }) {
            return [
              _c(
                "td",
                {
                  staticClass: "justify-center",
                  attrs: { colspan: headers.length },
                },
                [
                  _c(
                    VRow,
                    { attrs: { dense: "" } },
                    [
                      _c(VSpacer),
                      _c(
                        VCol,
                        [
                          _c(VRow, { staticClass: "justify-center" }, [
                            _c(
                              "h2",
                              {
                                staticClass:
                                  "title primary--text text--darken-1 text-no-wrap",
                              },
                              [_vm._v(" COMPETÊNCIAS TÉCNICAS ")]
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(VSpacer),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    [
                      _c(VSpacer),
                      _c(
                        VCol,
                        { attrs: { cols: "10" } },
                        [
                          _c(VSimpleTable, {
                            staticClass: "elevation-0 mb-4",
                            attrs: { dense: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function () {
                                    return [
                                      _c(
                                        "tbody",
                                        _vm._l(
                                          _vm.colunas.lista,
                                          function (column) {
                                            return _c(
                                              "tr",
                                              { key: column.id },
                                              _vm._l(
                                                column,
                                                function (competencia) {
                                                  return _c(
                                                    "td",
                                                    {
                                                      key: competencia.nome,
                                                      attrs: { width: "30%" },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "d-flex flex-row ma-1",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              class:
                                                                competencia.tipo ===
                                                                "GERAL"
                                                                  ? "secondary--text"
                                                                  : "grey-text text--darken-2",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  competencia.nome
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                      _c(VSpacer),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          },
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }